import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import axios from "../axios";
import { selected_authentication_server } from "../deployment-config";
import { useDispatch, useSelector } from "react-redux";
import { setLenderID } from "../store/reducers/accountSlice";
import { addAccountFormOptions } from "../Utils/formOptions";
import {
  LabelInput,
  LoadingButton,
  customStylesForMultiSelect,
} from "../Utils/CustomComponent";
import { toast } from "react-toastify";
import { commonToast } from "../Utils";
import { useSetUserLoggedIn } from "./Login/LoginComp";
import useLogout from "../hooks/useLogout";
import Select from "react-select";
import { Form, InputGroup } from "react-bootstrap";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import urls from "../Utils/urls";
import { oracleConfig } from "../Utils/constant";
import { setDashboardStatus } from "../store/reducers/dashboardSlice";
import { useAbortController } from "../hooks/useAbortController";

export default function AddAccount() {
  const [promptFail, setPromptFail] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  const [otpEntered, setOtpEntered] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [addAccountError, setAddAccountError] = useState(null);
  const [disableFormWhileSubmitting, setDisableFormWhileSubmitting] =
    useState();
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [disableFWS, setDisableFWS] = useState(false);
  const [parsedRes, setParsedRes] = useState([]);
  const [buttonText, setButtonText] = useState("Add Account");
  const [firstStepDone, setFirstStepDone] = useState(false);
  const logout = useLogout();
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const userId = localStorage.getItem("apex_userid");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setUserLoggedIn = useSetUserLoggedIn();
  const { resetController } = useAbortController();

  const addAccountFormSchema = {
    resolver: yupResolver(
      Yup.object().shape({
        account: Yup.string().required("Account is mandatory"),
        key: Yup.string()
          .required("4 digit TIN/SSN is mandatory")
          .matches(/^\d{4}$/, "TIN/SSN must be exactly 4 digits"),
        ...(emailOptions.length > 1 && {
          emails: Yup.string().required("Email is mandatory"),
        }),
      })
    ),
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    clearErrors,
  } = useForm({ mode: "all", ...addAccountFormSchema });

  const emailVal = emailOptions?.filter(
    (data) => data.value === watch("emails")
  )[0];

  useEffect(() => {
    if (emailVal?.value) {
      clearErrors("emails");
    }
  }, [emailVal]);

  const onSubmit = async (data) => {
    data.userid = localStorage.getItem("apex_userid");
    setDisableFormWhileSubmitting(true);
    const id = toast.loading("Processing request");
    try {
      const data2 = { AccountNumber: data.account, TIN: data.key };
      const res = await axios.post(
        urls.account.addAccount,
        data2,
        selected_authentication_server.add_account.headers
        // selected_authentication_server.add_account.endpoint,
        // "https://api.loanlinq.com/api/v1/accounts/add-account",
      );

      const filteredRes = res?.data?.[0]?.[0];
      if (res?.data?.[0]?.length) {
        const firstKey = Object?.keys(filteredRes)?.[0];
        const parsedData = JSON.parse(filteredRes[firstKey]);
        setFirstStepDone(true);
        setButtonText("Continue");
        setParsedRes(parsedData[0]);
        const emails = parsedData[0].EmailAddress?.split(",");
        if (emails.length > 1) {
          const emailsObj = emails.map((item) => ({
            label: item,
            value: item,
          }));
          setEmailOptions(emailsObj);
        } else {
          setSelectedEmail(emails[0]);
          handleOtp(emails[0]);
        }
      } else {
        setPromptFail("Invalid Account and/or TIN. Please try again.");
      }
      // if (res?.data?.status && res?.data?.status === "404") {
      //   setAddAccountError(res.data.error[0].message);
      //   toast.update(id, {
      //     render: "Error " + res.data.error[0].message,
      //     type: "error",
      //     isLoading: false,
      //     ...commonToast,
      //   });
      //   setTimeout(() => {
      //     setAddAccountError(null);
      //     setDisableFormWhileSubmitting(false);
      //   }, 4000);
      // } else if (res?.data?.status === "200") {
      //   const res2 = await axios.post(
      //     selected_authentication_server.access_account.endpoint,
      //     { userid: localStorage.getItem("apex_userid") },
      //     selected_authentication_server.access_account.headers
      //   );
      //   if (res2?.data?.account?.[0]?.recid) {
      //     dispatch(setLenderID(res2?.data?.account?.[0]?.recid));
      //     setUserLoggedIn({
      //       res: res2,
      //     });
      //     toast.update(id, {
      //       render: "Account Added Succesfuly",
      //       type: "success",
      //       isLoading: false,
      //       ...commonToast,
      //     });
      //     setTimeout(() => {
      //       navigate("/");
      //     }, 4000);
      //   }
      // }
    } catch (error) {
      console.error("onSubmit", error);
      toast.update(id, {
        render: "Error " + error.message,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      setDisableFormWhileSubmitting(false);
    } finally {
      setTimeout(() => {
        toast.dismiss(id);
      }, 1000);
      setDisableFormWhileSubmitting(false);
    }
  };
  const newLogout = () => {
    logout();
  };

  async function handleOtp(email) {
    const id = toast.loading("Generating otp");
    setDisableFormWhileSubmitting(true);
    const data = {
      email_address: email,
    };
    try {
      const res = await axios.post(urls.account.sendOtp, data, oracleConfig);
      if (res.status == "200") {
        setShowOtpInput(true);
        toast.update(id, {
          render: "OTP generated and sent to your mail",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Error " + error?.message,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
    } finally {
      setDisableFormWhileSubmitting(false);
      setTimeout(() => {
        toast.dismiss(id);
      }, 1000);
    }
  }

  function handleMailSelecetion(selected) {
    setValue("emails", selected.value);
    setSelectedEmail(selected.value);
    handleOtp(selected.value);
  }

  async function validateOTP() {
    const id = toast.loading("Adding account in progress");
    setDisableFWS(true);
    try {
      const data = {
        email_address: selectedEmail,
        otp: otpEntered,
      };
      const res = await axios.post(
        urls.account.validateOtp,
        data,
        oracleConfig
      );

      if (res.status == "200") {
        const data2 = {
          recid: parsedRes.RecID,
          roletype: parsedRes.role,
          database: parsedRes.databasename,
          user_id: Number(userId),
        };
        const res2 = await axios.post(
          urls.account.addAccountManual,
          data2,
          oracleConfig
        );
        if (res2.status == "200") {
          navigateToAccount();
          toast.update(id, {
            render: "Account added successfully",
            type: "success",
            isLoading: false,
            ...commonToast,
          });
        }
      }
    } catch (error) {
      console.error(error);
      toast.update(id, {
        render: "Error " + error?.message,
        type: "error",
        isLoading: false,
        ...commonToast,
      });
      setPromptFail("Invalid OTP");
    } finally {
      setDisableFWS(false);
      setTimeout(() => {
        toast.dismiss(id);
      }, 1000);
    }
  }

  const navigateToAccount = async () => {
    setDisableFWS(true);
    try {
      // Second API call if OTP is correct
      const res2 = await axios.post(
        selected_authentication_server.access_account.endpoint,
        { userid: localStorage.getItem("apex_userid") },
        selected_authentication_server.access_account.headers
      );
      if (res2?.data?.account?.[0]?.recid) {
        resetController();
        dispatch(setDashboardStatus("idle"));
        setUserLoggedIn({
          res: res2,
        });
      }
    } catch (error) {
      console.error("Failed to verify user:", error);
      setPromptFail("Failed to verify OTP. Please try again.");
    }
  };

  return (
    <>
      <div className="d-flex flex-column ">
        {/* SIGNUP */}
        {
          <div
            style={{ height: "80vh", width: "100%" }}
            className="d-flex align-items-center justify-content-center container-fluid"
          >
            <div
              className="text-start"
              style={{ position: "relative", width: "500px" }}
            >
              <h3>Add Account</h3>
              <form onSubmit={handleSubmit(onSubmit)}>
                <LabelInput
                  labelProps={{
                    title: "Account",
                    props: {
                      htmlFor: "account",
                    },
                    className: "text-start d-block mt-3",
                  }}
                  inputProps={{
                    className: `form-control ${
                      errors.account ? "is-invalid" : ""
                    }`,
                    type: "text",
                    disabled: disableFormWhileSubmitting || firstStepDone,
                    id: "account",
                    ...register("account"),
                  }}
                  error={errors.account?.message}
                />
                <LabelInput
                  labelProps={{
                    title: "Last 4 digit for your TIN / SSN",
                    props: {
                      htmlFor: "4 digit TIN",
                    },
                    className: "text-start d-block mt-3",
                  }}
                  inputProps={{
                    className: `form-control ${
                      errors.key ? "text-start is-invalid" : ""
                    }`,
                    type: "text",
                    disabled: disableFormWhileSubmitting || firstStepDone,
                    id: "key",
                    ...register("key"),
                  }}
                  error={errors.key?.message}
                />

                {emailOptions?.length > 1 ? (
                  <div className="mt-4">
                    <label htmlFor="emails">Select email to receive OTP:</label>
                    <Select
                      name={"emails"}
                      placeholder=""
                      options={emailOptions}
                      {...register("emails")}
                      value={emailVal || null}
                      onChange={(selected) => {
                        handleMailSelecetion(selected);
                      }}
                      styles={customStylesForMultiSelect}
                      className={
                        errors?.["emails"]?.message && !emailVal?.value
                          ? "is-invalid"
                          : ""
                      }
                    />
                    {errors?.emails && (
                      <div className="d-block invalid-feedback">
                        {errors?.["emails"]?.message}
                      </div>
                    )}
                  </div>
                ) : null}

                {showOtpInput ? (
                  <div className="form-outline mb-1">
                    <OTPInputComponent
                      setOtpEntered={setOtpEntered}
                      email={selectedEmail}
                    />
                  </div>
                ) : null}

                <div className="row mt-2">
                  <div className="col">
                    {!showOtpInput ? (
                      <input
                        disabled={disableFormWhileSubmitting}
                        value={buttonText}
                        className="mt-5 btn btn-primary me-5"
                        type="submit"
                      />
                    ) : (
                      <LoadingButton
                        className="mt-5 btn btn-primary me-5"
                        type="button"
                        onClick={() => validateOTP()}
                        disabled={disableFWS || otpEntered?.length < 6}
                        loading={disableFWS}
                        title={"Submit"}
                      />
                    )}
                    {!accountOptions?.length && (
                      <button
                        className="mt-5 btn btn-error"
                        style={{ color: "white" }}
                        onClick={() => {
                          newLogout();
                        }}
                      >
                        Logout
                      </button>
                    )}
                  </div>
                </div>
              </form>
              {/* <div className="d-flex align-items-center justify-content-center mt-4">
                {addAccountError ? (
                  <p className="alert alert-info w-100">{addAccountError}</p>
                ) : null}
              </div> */}
              <div className="d-flex align-items-center justify-content-center mt-4">
                {promptFail ? (
                  <p className="text-center alert alert-info w-100">
                    {promptFail}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
}

const OTPInputComponent = ({ setOtpEntered, email }) => {
  const length = 6; // Length of OTP
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [label, setLabel] = useState("");
  const inputsRef = useRef(new Array(length).fill(React.createRef()));

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false; // If not a number, don't process

    // Update OTP array
    const newOtp = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ];
    setOtp([...newOtp]);
    setOtpEntered(newOtp.join(""));

    // Focus next input on value entry, previous if empty (backspace/delete)
    if (element.value !== "") {
      // Move to next input if available
      if (element.nextSibling) {
        element.nextSibling.focus();
      }
    } else if (element.previousSibling) {
      // Move to previous input on backspace/delete if available
      element.previousSibling.focus();
    }
  };

  useEffect(() => {
    // Automatically focus the first input on component mount
    inputsRef.current[0].focus();
  }, []);

  useEffect(() => {
    const maskedEmail = maskEmail(email);
    setLabel(maskedEmail);
  }, [email]);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text/plain")
      .slice(0, length)
      .split("");
    if (pastedData?.length === length) {
      setOtp([...pastedData]);
      setOtpEntered(pastedData.join(""));
      inputsRef.current[length - 1].focus();
    }
  };

  return (
    <>
      <label>An OTP has been sent to {label}:</label>
      <InputGroup className="gap-5 mt-5">
        {Array.from({ length }, (_, index) => (
          <Form.Control
            key={index}
            type="text"
            maxLength="1"
            style={{
              width: "3rem",
              textAlign: "center",
              borderRadius: "0.25rem",
            }}
            value={otp[index]}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => {
              // When the user presses backspace and the input is empty, focus the previous input
              if (e.key === "Backspace" && !otp[index]) {
                const prevInput = inputsRef.current[index - 1];
                if (prevInput) {
                  prevInput.focus();
                }
              }
            }}
            onPaste={handlePaste}
            ref={(ref) => (inputsRef.current[index] = ref)}
            className="inputStyle form-control input-lg p-5"
          />
        ))}
      </InputGroup>
    </>
  );
};

const maskHalfPreservePattern = (str) => {
  const length = str.length;
  const halfLength = Math.floor(length / 2);

  // Mask the second half of the string to maintain the word pattern
  return str.slice(0, halfLength) + "*".repeat(halfLength);
};

const maskEmail = (email) => {
  const [username, domain] = email.split("@");

  // Mask 50% of the username, preserving the pattern
  const maskedUsername = maskHalfPreservePattern(username);

  // Split the domain into name and TLD parts
  const domainParts = domain.split(".");
  const domainName = domainParts.slice(0, -1).join("."); // everything except the last part
  const topLevelDomain = domainParts[domainParts.length - 1]; // the last part (e.g., 'com')

  // Mask 50% of the domain name, preserving the pattern
  const maskedDomainName = maskHalfPreservePattern(domainName);

  return `${maskedUsername}@${maskedDomainName}.${topLevelDomain}`;
};
